var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / ZA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-ZA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#06A86E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83",
    fill: "#FFBF2E",
    mask: "url(#mask-2)",
    points: "0 2.66666667 9.33333333 10 0 17.3333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83-Copy-5",
    fill: "#262626",
    mask: "url(#mask-2)",
    points: "-1.33333333 3 7.66666667 10 -1.33333333 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83-Copy",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "12 8 2.66666667 0 28 0 28 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83-Copy-3",
    fill: "#F44E46",
    mask: "url(#mask-2)",
    points: "12.3333333 6.66666667 4.33333333 0 28 0 28 6.66666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83-Copy-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "2.66666667 20 28 20 28 12 12 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83-Copy-4",
    fill: "#072CB4",
    mask: "url(#mask-2)",
    points: "4.33333333 20 28 20 28 13.3333333 12.3333333 13.3333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/ZA.dcd2881033003ca2a32578cb83d7ea30.svg";
export { ForwardRef as ReactComponent };